<div [class.fixed]="isSectionInline ? null : true">
  <nz-spin [nzSpinning]="isLoading">
    <ng-content></ng-content>
  </nz-spin>
</div>
